import axios from 'axios';

/**
 * A number, or a string containing a number.
 * @typedef {Object} SupportTicketRequest
 * @property {string} name
 * @property {string} email
 * @property {string} message

 */



const chatApi = {
    /**
     *
     * @param {object} newChatRequest
     * @param {string} newChatRequest.name
     * @returns {Promise<void>}
     */
    async newChat(newChatRequest) {
        const url = '/api/chat';
        const response = await axios.post(url, newChatRequest);
        return response.data.response;
    },
    /**
     * @param {string} chatId
     * @param {Object} chatMessageRequest
     * @param {string} chatMessageRequest.chatId
     * @param {string} chatMessageRequest.message
     * @param {number} chatMessageRequest.timestamp
     * @param {string} chatMessageRequest.chatMessage
     * @param {number} chatMessageRequest.temperature
     * @param {number} chatMessageRequest.indexName
     * @returns {Promise<void>}
     */
    async newChatMessage(chatId, chatMessageRequest) {
        const url = `/api/chat/${chatId}/message`;
        chatMessageRequest.timestamp = new Date().getTime()
        const response = await axios.post(url, chatMessageRequest);
        return response.data.response;
    },
    async getChats() {
        const responseData = await axios.get('/api/chat');
        const chats = responseData.data.response;
        chats.forEach(chat => {
            const noDecimal = parseInt(chat.timestamp);
            chat.timestamp = new Date(noDecimal);
        });
        return chats;
    },
    async rating(message, rating) {
        ///api/chat/{chat_id}/message/{message_id}/rating/{rating}
        const url = `/api/chat/${message.chatId}/message/${message.originalId}/rating/${rating}`;
        const response = await axios.post(url, null);
        return response.data;
    },
    async getChatMessages(chatId) {
        const response = await axios.get(`/api/chat/${chatId}/message`);
        return response.data.response;
    },

  /**
   * @param object message
   * @param {SupportTicketRequest} supportTicketRequest
   * @returns {Promise<void>}
   */
  async postSupportTicket(message, supportTicketRequest) {
    const url = `/api/chat/${message.chatId}/message/${message.originalId}/support_request`;
    const response = await axios.post(url, supportTicketRequest);
    return response.data;
  },
  async getPrompt(language, k) {
    const params = { language, k };
    const url = `/api/prompt`;
    const response = await axios.get(url, { params });
    return response.data.response;
  },
  async savePrompt(prompt, language, k) {
    const params = { k };
    const url = `/api/prompt`;
    const data = {
      indexName: language,
      prompt,
    }
    const response = await axios.post(url, data, { params });
    return response.data.response;
  }
};

export default chatApi;
